$(document).ready(function () {
  let p = $('body').attr('p');
  if (p === 'admin_organizers' || p === 'admin_organizer_setting') {
    function deactivateOrganizer(organizer_id, status) {
      $.ajax({
        type: 'POST',
        url: '/ajax/organizer_settings/deactivate',
        data: {
          organizer_id,
          status,
        },
        })
        .done(function (data) {
          if (data.message !== undefined && data.message !== null) {
            const messageContainer = $('#modal-footer-' + organizer_id).length
              ? '#modal-footer-' + organizer_id
              : '#footer-' + organizer_id;
            prependAlert(
              messageContainer,
              data.message,
              'success',
              null,
              '#modal-organizer-' + organizer_id
            );
            $(
              '#deactivated-log-in-as-organizer-id-' + organizer_id
            ).removeClass('d-none');
            $('#activated-log-in-as-organizer-id-' + organizer_id).addClass(
              'd-none'
            );
            if (p === 'admin_organizers') {
              $('#organizer-' + organizer_id).remove();
            }
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    function reactivateOrganizer(organizer_id, status) {
      let reactivate = true;
      $.ajax({
        type: 'POST',
        url: '/ajax/organizer_settings/update',
        data: {
          organizer_id,
          status,
          reactivate,
        },
        })
        .done(function (data) {
          if (data.message !== undefined && data.message !== null) {
            const messageContainer = $('#modal-footer-' + organizer_id).length
              ? '#modal-footer-' + organizer_id
              : '#footer-' + organizer_id;
            prependAlert(
              messageContainer,
              data.message,
              'success',
              null,
              '#modal-organizer-' + organizer_id
            );
            $('#deactivated-log-in-as-organizer-id-' + organizer_id).addClass(
              'd-none'
            );
            $('#activated-log-in-as-organizer-id-' + organizer_id).removeClass(
              'd-none'
            );
            if (p === 'admin_organizers') {
              $('#organizer-' + organizer_id).remove();
            }
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    function updateOrganizerDemoStatus(organizerId, isDemo) {
      $.ajax({
        type: 'POST',
        url: '/ajax/organizer_settings/update',
        data: {
          organizer_id: organizerId,
          is_demo: isDemo,
          update_demo_status: true,
        },
      })
        .done(function (data) {
          if (data.message !== undefined && data.message !== null) {
            const messageContainer = $('#modal-footer-' + organizerId).length
              ? '#modal-footer-' + organizerId
              : '#footer-' + organizerId;
            prependAlert(
              messageContainer,
              data.message,
              'success',
              null,
              '#modal-organizer-' + organizerId
            );

            if (p === 'admin_organizers') {
              $('#organizer-' + organizerId).remove();
            }
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    $(document).on('click', '.organizer-deactivate', function (e) {
      e.preventDefault();
      const confirmMessage = $(this).attr('data-confirm-message');
      if (!confirm(confirmMessage)) {
        return;
      }
      let organizer_id = $(this).attr('data-deactivate-organizer-id');
      let status = $(this).attr('data-status');
      if (!$(this).hasClass('d-none')) {
        $(this).addClass('d-none');
      }
      if (
        $('[data-reactivate-organizer-id=' + organizer_id + ']').hasClass(
          'd-none'
        )
      ) {
        $('[data-reactivate-organizer-id=' + organizer_id + ']').removeClass(
          'd-none'
        );
      }
      $('#alert-warning-' + organizer_id).remove();
      deactivateOrganizer(organizer_id, status);
    });

    $(document).on('click', '.organizer-reactivate', function (e) {
      e.preventDefault();
      const confirmMessage = $(this).attr('data-confirm-message');
      if (!confirm(confirmMessage)) {
        return;
      }
      let organizerId = $(this).attr('data-reactivate-organizer-id');
      let status = $(this).attr('data-status');
      if (!$(this).hasClass('d-none')) {
        $(this).addClass('d-none');
      }
      if (
        $('[data-deactivate-organizer-id=' + organizerId + ']').hasClass(
          'd-none'
        )
      ) {
        $('[data-deactivate-organizer-id=' + organizerId + ']').removeClass(
          'd-none'
        );
      }
      reactivateOrganizer(organizerId, status);
    });

    $(document).on(
      'click',
      '.organizer-mark-demo, .organizer-remove-demo',
      function (e) {
        e.preventDefault();
        const confirmMessage = $(this).attr('data-confirm-message');
        if (!confirm(confirmMessage)) {
          return;
        }

        const organizerId = $(this).attr('data-organizer-id');
        const isDemo = $(this).attr('data-is-demo');
        $(
          '.organizer-mark-demo[data-organizer-id=' + organizerId + ']'
        ).toggleClass('d-none');
        $(
          '.organizer-remove-demo[data-organizer-id=' + organizerId + ']'
        ).toggleClass('d-none');
        $('#demo-badge-' + organizerId).toggleClass('d-none');
        updateOrganizerDemoStatus(organizerId, isDemo);
      }
    );
  }
});
